const NO_KEY_ERROR = 'NoKeyError';

class NoKeyError extends Error {
  constructor() {
    super('user has no private key');
    this.name = NO_KEY_ERROR;
  }
}

export default NoKeyError;
